/**
 * A slow clock for age captions ("12s ago" must not freeze). Re-renders the
 * subscribing component every `ms` — mounted only by components that are
 * actually showing a live age, so idle views tick nothing.
 */

import { useEffect, useState } from 'react';

export function useNowTick(ms = 10_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms]);
  return now;
}
